import type { SedrStarterSetFolder } from '../../api/sedr';

export function folderDepth(folders: SedrStarterSetFolder[], folderId: string): number {
  let depth = 0;
  let current = folders.find((f) => f.id === folderId);
  while (current?.parentId) {
    depth += 1;
    current = folders.find((f) => f.id === current!.parentId);
  }
  return depth;
}

export function sortedFolderTree(folders: SedrStarterSetFolder[]): SedrStarterSetFolder[] {
  const byParent = new Map<string, SedrStarterSetFolder[]>();
  for (const folder of folders) {
    const key = folder.parentId ?? '';
    const list = byParent.get(key) ?? [];
    list.push(folder);
    byParent.set(key, list);
  }
  for (const list of byParent.values()) {
    list.sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name));
  }
  const result: SedrStarterSetFolder[] = [];
  const visit = (parentId: string | null) => {
    const children = byParent.get(parentId ?? '') ?? [];
    for (const child of children) {
      result.push(child);
      visit(child.id);
    }
  };
  visit(null);
  return result;
}
